module.exports = __webpack_public_path__ + "static/reviewer_4-35da386c7062847ffa543c0bec6f4abf.png";